import React from 'react';

const HowItWorksSection = () => {
  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        {/* Başlık */}
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2">
            Nasıl Çalışır?
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-md mx-auto">
            3 kolay adımda profesyonel hizmete ulaşın
          </p>
        </div>
        
        {/* Adımlar - Desktop */}
        <div className="hidden md:block space-y-16">
          {/* Adım 1 */}
          <div className="flex items-center gap-12">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#006D77] rounded-full flex items-center justify-center text-white font-bold text-lg">1</div>
                <span className="text-[#006D77] font-semibold text-sm uppercase tracking-wide">Birinci Adım</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">İhtiyacını birkaç soruda anlat</h3>
              <p className="text-gray-600 leading-relaxed">
                İhtiyacına özel soruları cevapla ve iletişim bilgilerini gir. Yapay zeka ile tahmini fiyat aralığını hemen gör.
              </p>
            </div>
            <div className="flex-1">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/84fc7f27-88da-4cbc-8349-efcf97b1d474/images/6352fe89ce0b7f027d7652ce6b7df01352d4a66a7dcf4d2f8547c0411eecdfda.png" 
                alt="Hizmet seçimi" 
                className="w-full max-w-md mx-auto rounded-2xl shadow-lg"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          {/* Adım 2 */}
          <div className="flex items-center gap-12 flex-row-reverse">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#E29578] rounded-full flex items-center justify-center text-white font-bold text-lg">2</div>
                <span className="text-[#E29578] font-semibold text-sm uppercase tracking-wide">İkinci Adım</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Detayları gir, talep oluştur</h3>
              <p className="text-gray-600 leading-relaxed">
                Sorunu ve adresini belirt. Sadece 2 dakikada formu tamamla ve talebini gönder.
              </p>
            </div>
            <div className="flex-1">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/84fc7f27-88da-4cbc-8349-efcf97b1d474/images/ce75c0aea2012ec924177c4b4f83efc521985dafcdbadb6681e68b5c937dba07.png" 
                alt="Form doldurma" 
                className="w-full max-w-md mx-auto rounded-2xl shadow-lg"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          {/* Adım 3 */}
          <div className="flex items-center gap-12">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#059669] rounded-full flex items-center justify-center text-white font-bold text-lg">3</div>
                <span className="text-[#059669] font-semibold text-sm uppercase tracking-wide">Üçüncü Adım</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Onaylı usta kapına gelsin</h3>
              <p className="text-gray-600 leading-relaxed">
                Uzman ustamız seninle iletişime geçsin ve işini garantili şekilde tamamlasın. Memnuniyet garantisi bizden.
              </p>
            </div>
            <div className="flex-1">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/84fc7f27-88da-4cbc-8349-efcf97b1d474/images/7883c7898d4e7e1accc8c68c61c7ccae7498bbe4ee057233e3573bb155026241.png" 
                alt="Usta gelişi" 
                className="w-full max-w-md mx-auto rounded-2xl shadow-lg"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>

        {/* Adımlar - Mobil */}
        <div className="md:hidden space-y-8">
          {/* Adım 1 - Mobil */}
          <div className="text-center">
            <img 
              src="https://static.prod-images.emergentagent.com/jobs/84fc7f27-88da-4cbc-8349-efcf97b1d474/images/6352fe89ce0b7f027d7652ce6b7df01352d4a66a7dcf4d2f8547c0411eecdfda.png" 
              alt="Hizmet seçimi" 
              className="w-full max-w-xs mx-auto rounded-xl shadow-md mb-4"
              loading="lazy"
              decoding="async"
            />
            <div className="flex items-center justify-center gap-2 mb-2">
              <div className="w-8 h-8 bg-[#006D77] rounded-full flex items-center justify-center text-white font-bold text-sm">1</div>
              <h3 className="font-bold text-gray-900">İhtiyacını anlat</h3>
            </div>
            <p className="text-gray-600 text-sm px-4">
              Soruları cevapla, tahmini fiyatı gör
            </p>
          </div>

          {/* Adım 2 - Mobil */}
          <div className="text-center">
            <img 
              src="https://static.prod-images.emergentagent.com/jobs/84fc7f27-88da-4cbc-8349-efcf97b1d474/images/ce75c0aea2012ec924177c4b4f83efc521985dafcdbadb6681e68b5c937dba07.png" 
              alt="Form doldurma" 
              className="w-full max-w-xs mx-auto rounded-xl shadow-md mb-4"
              loading="lazy"
              decoding="async"
            />
            <div className="flex items-center justify-center gap-2 mb-2">
              <div className="w-8 h-8 bg-[#E29578] rounded-full flex items-center justify-center text-white font-bold text-sm">2</div>
              <h3 className="font-bold text-gray-900">Talep oluştur</h3>
            </div>
            <p className="text-gray-600 text-sm px-4">
              Detayları gir, 2 dakikada gönder
            </p>
          </div>

          {/* Adım 3 - Mobil */}
          <div className="text-center">
            <img 
              src="https://static.prod-images.emergentagent.com/jobs/84fc7f27-88da-4cbc-8349-efcf97b1d474/images/7883c7898d4e7e1accc8c68c61c7ccae7498bbe4ee057233e3573bb155026241.png" 
              alt="Usta gelişi" 
              className="w-full max-w-xs mx-auto rounded-xl shadow-md mb-4"
              loading="lazy"
              decoding="async"
            />
            <div className="flex items-center justify-center gap-2 mb-2">
              <div className="w-8 h-8 bg-[#059669] rounded-full flex items-center justify-center text-white font-bold text-sm">3</div>
              <h3 className="font-bold text-gray-900">Usta gelsin</h3>
            </div>
            <p className="text-gray-600 text-sm px-4">
              Onaylı usta kapında, garanti bizden
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
